import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { AssignShipmentAction } from '@shared-features/enums/assign-shipment-action.enum';
import { RunningShipmentCheckType } from '@shared-features/enums/running-shipment-check-type.enum';
import { Shipment } from '@shared-features/models/shipment';
import { SharedApiService } from '@shared-features/services/shared-api.service';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { catchError, takeUntil } from 'rxjs/operators';
import { of } from 'rxjs';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-shipment-assignment-action-wrapper',
  templateUrl: './shipment-assignment-action-wrapper.component.html',
  styleUrls: ['./shipment-assignment-action-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShipmentAssignmentActionWrapperComponent extends BaseComponent implements OnChanges {
  @Input() shipmentId: number;
  @Input() isViewActions: boolean = true;
  @Input() driverId: number;
  @Input() truckId: number;
  @Input() form: FormGroup;

  @Output() assignShipmentActionChange = new EventEmitter<{
    assignShipmentAction: AssignShipmentAction;
    justification: string;
  }>();

  driverRunningShipment: Shipment;
  truckRunningShipment: Shipment;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private sharedApiService: SharedApiService
  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.driverId) {
      this.getDriverRunningShipment();
    }
    if (changes.truckId) {
      this.getTruckRunningShipment();
    }
  }

  getDriverRunningShipment(): void {
    this.driverRunningShipment = null;
    if (!this.driverId) {
      return;
    }
    this.sharedApiService
      .getRunningShipments({
        driverId: this.driverId,
        type: RunningShipmentCheckType.Driver,
      })
      .pipe(
        takeUntil(this.destroy$),
        catchError(() => of(null))
      )
      .subscribe((driverRunningShipment) => {
        this.driverRunningShipment = driverRunningShipment;
        this.setAssignShipmentAction(driverRunningShipment);
        this.changeDetectorRef.markForCheck();
      });
  }

  getTruckRunningShipment(): void {
    this.truckRunningShipment = null;
    if (!this.truckId) {
      return;
    }
    this.sharedApiService
      .getRunningShipments({
        truckId: this.truckId,
        type: RunningShipmentCheckType.Truck,
      })
      .pipe(
        takeUntil(this.destroy$),
        catchError(() => of(null))
      )
      .subscribe((truckRunningShipment) => {
        this.truckRunningShipment = truckRunningShipment;
        this.setAssignShipmentAction(truckRunningShipment);
        this.changeDetectorRef.markForCheck();
      });
  }


  private setAssignShipmentAction(runningShimpment: Shipment) {
    if (runningShimpment) {
      this.assignShipmentActionChange.emit({
        assignShipmentAction: AssignShipmentAction.Override,
        justification: ''
      });
    } else {
      this.assignShipmentActionChange.emit(null);
    }
  }
}
